// Only volume pages with "More information" have the toggle
const moreInformationButton = document.querySelector(".more-information__button");

if (moreInformationButton) {
	moreInformationButton.addEventListener("click", () => {
		document.querySelector(".more-information").classList.toggle("active");
	})
}
